module.exports = __webpack_public_path__ + "img/AT0000002657052.b33db786.png";